import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Merge Overlapping Intervals",
  url: "merge-overlapping-intervals",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {Array[][]} arr
* @return {Array[][]}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function mergeIntervals(arr) {
  // your code goes here        
};
`,
};

export default info;
